'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _config = require('../../../redux/modules/config');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _LACrown = require('./LACrown');

var _LACrown2 = _interopRequireDefault(_LACrown);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
    return {
        baseUrl: (0, _config.getBaseUrl)(state),
        classicBaseUrl: (0, _config.getClassicBaseUrl)(state)
    };
};

var LACrownContainer = function (_Component) {
    (0, _inherits3.default)(LACrownContainer, _Component);

    function LACrownContainer() {
        (0, _classCallCheck3.default)(this, LACrownContainer);
        return (0, _possibleConstructorReturn3.default)(this, (LACrownContainer.__proto__ || (0, _getPrototypeOf2.default)(LACrownContainer)).apply(this, arguments));
    }

    (0, _createClass3.default)(LACrownContainer, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                baseUrl = _props.baseUrl,
                classicBaseUrl = _props.classicBaseUrl,
                location = _props.location;


            return (0, _jsx3.default)(_LACrown2.default, {
                baseUrl: baseUrl,
                classicBaseUrl: classicBaseUrl,
                location: location
            });
        }
    }]);
    return LACrownContainer;
}(_react.Component);

exports.default = (0, _reactRedux.connect)(mapStateToProps)(LACrownContainer);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/LACrown/LACrownContainer.js
// module id = YBb+
// module chunks = 57